import axiosRequest from '@/utils/axios'
import { axios as Axios } from '@/utils/axios'
/** 拼接参数 */
function __fParams(params) {
    if (!params || !Object.keys(params).length) return ''
    let paramsStr = ''
    for (let i in params) {
      paramsStr += `${i}=${params[i]}&`
    }
    return paramsStr.substr(0, paramsStr.length - 1)
  }
// 文生图
export const textGenerate = (params) =>
    axiosRequest.get(`/gateway-apis/moyin-tool/v1/generateImage/text?${__fParams(params)}`)
// 生成图片结果轮训
export const generateImage = (params) =>
    axiosRequest.get(`/gateway-apis/moyin-tool/v1/generateImage/queryResult?${__fParams(params)}`)

export const generateImageList = (params) =>
    axiosRequest.get(`/gateway-apis/moyin-tool/v1/generateImage/list?${__fParams(params)}`)
// 图生图
export const imageGenerate = (data) =>
    axiosRequest.post(`/gateway-apis/moyin-tool/v1/generateImage/image`,data)

// 取消生成
export const cancelGenerate = (data) =>
    axiosRequest.post(`/gateway-apis/moyin-tool/v1/generateImage/rollback`,data)

export default {
    // 随机生成文案
    randomPrompt: () =>
        Axios({
          url: '/gateway-apis/moyin-tool/v1/generateImage/randomPrompt',
          method: 'GET',
        }),
    // 删除history数据
    historyDelete: (data) =>
        Axios({
            url: '/gateway-apis/moyin-tool/v1/generateImage/batchDelete',
            method: 'DELETE',
            data
        }),
    imageReport: (data) =>
        Axios({
            url: '/gateway-apis/moyin-tool/v1/generateImage/report',
            method: 'POST',
            data
        }),

    textGenerate,
    generateImage,
    generateImageList,
    imageGenerate,
    cancelGenerate
}